import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardAdminComponent } from './card-admin/card-admin.component';
import { ShowProductComponent } from './show-product/show-product.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CreateCategoryComponent } from './create-category/create-category.component';
import { EditProductComponent } from './edit-product/edit-product.component';
import { CreateBankComponent } from './create-bank/create-bank.component';
import { SliderImagesComponent } from './slider-images/slider-images.component';
import { BtnAdminComponent } from './btn-admin/btn-admin.component';
import { ImagesCataloguesComponent } from './images-catalogues/images-catalogues.component';
import { CardImageCatalogueComponent } from './card-image-catalogue/card-image-catalogue.component';
import { CategoriesComponent } from './categories/categories.component';
import { CreateCurrencyComponent } from './create-currency/create-currency.component';
import { BuyDataComponent } from './buy-data/buy-data.component';
import { PaymentsComponent } from './payments/payments.component';
import { OrdersComponent } from './orders/orders.component';
import { InfoMethodComponent } from './info-method/info-method.component';
import { InfoProductComponent } from './info-product/info-product.component';
import { HeaderAdminComponent } from './header-admin/header-admin.component';
import { UsersComponent } from './users/users.component';

import { ActiveUserComponent } from './active-user/active-user.component';
import { PagerAdminComponent } from './pager/pager.component';
import { PipeModule } from 'src/app/pipes/pipe-module.module';
import { ComponentsModuleModule } from 'src/app/components/components-module.module';
import { FormComponentComponent } from 'src/app/components/form-component/form-component.component';
import { CKEditorModule } from 'ckeditor4-angular';
import { OptionsProductComponent } from './options-product/options-product.component';
import { DataProductComponent } from './data-product/data-product.component';
import { DescripcionProductComponent } from './descripcion-product/descripcion-product.component';
import { ProductListComponent } from './product-list/product-list.component';
import { BuscadorAdminComponent } from './buscador-admin/buscador-admin.component';
import { ContactComponent } from './contact/contact.component';
import { PaymentListComponent } from './payment-list/product-list.component';
import { DetailPaymentComponent } from './detail-payment/detail-payment.component';
import { CardTotalComponent } from './card-total/card-total.component';
import { MetricsComponent } from './metrics/metrics.component';
import { MetricProductsComponent } from './metric-products/metric-products.component';
import { ProductMetricCardComponent } from './product-metric-card/product-metric-card.component';
import { MetricsBarComponent } from './metrics-bar/metrics-bar.component';
import { AdminDashboardComponent } from '../pages-admin/admin-dashboard/admin-dashboard.component';
import { TransactionComponent } from 'src/app/componentsWallet/components/transaction/transaction.component';
import { UserActionsComponent } from 'src/app/components/user-actions/user-actions.component';
import { SegmentComponent } from 'src/app/components/segment/segment.component';
import { SelectionGiftCardComponent } from './selection-gift-card/selection-gift-card.component';
import { SubscriptionUserComponent } from './subscription-user/subscription-user.component';
import { LinkImageComponent } from './link-image/link-image.component';
import { TranslateModule } from '@ngx-translate/core';
import { DetailOrdenDirective } from 'src/app/directives/detail-orden.directive';

import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AttentionComponent } from './attention/attention.component';
import { ScheduleDispatchComponent } from './schedule-dispatch/schedule-dispatch.component';
import { RequestGroupComponent } from './request-group/request-group.component';
import { UserProofComponent } from './user-proof/user-proof.component';
import { GeneralesComponentsModule } from 'src/app/generales-components/generales-components.module';
import { DirectivesModule } from 'src/app/directives/directives.module';
import { BannerSlidesProductsComponent } from './banner-slides-products/banner-slides-products.component';
import { SlidersOfHomeSectionComponent } from './sliders-of-home-section/sliders-of-home-section.component';
import { DispatchComponent } from '../../vista-compra/components-compra/dispatch/dispatch.component';
import { MethodComponent } from '../../vista-compra/components-compra/method/method.component';
import { PasarelaPagoComponent } from '../../vista-compra/components-compra/pasarela-pago/pasarela-pago.component';
import { DecoratedTextComponent } from './decorated-text/decorated-text.component';
import { PipesCompraModule } from '../../vista-compra/pipes-compra/pipes-compra.module';
import { DeclineReasonComponent } from './decline-reason/decline-reason.component';
import { PrintDispatchComponent } from './print-dispatch/print-dispatch.component';
import { ComponentsCompraModule } from '../../vista-compra/components-compra/components-compra.module';

import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
} from '@danielmoncada/angular-datetime-picker';
import { FormGiftCardComponent } from 'src/app/components/form-gift-card/form-gift-card.component';
import { WithDrawDetailsComponent } from './with-draw-details/with-draw-details.component';
import { GroupOptionsComponent } from './group-options/group-options.component';
import { QrProfileComponent } from 'src/app/components/qr-profile/qr-profile.component';

const components = [
  ShowProductComponent,
  CardAdminComponent,
  CreateCategoryComponent,
  EditProductComponent,
  CreateBankComponent,
  SliderImagesComponent,
  BtnAdminComponent,
  ImagesCataloguesComponent,
  CardImageCatalogueComponent,
  CategoriesComponent,
  CreateCurrencyComponent,
  BuyDataComponent,
  PaymentsComponent,
  FormComponentComponent,
  FormGiftCardComponent,
  OrdersComponent,
  InfoMethodComponent,
  InfoProductComponent,
  HeaderAdminComponent,
  UsersComponent,
  ActiveUserComponent,
  PagerAdminComponent,
  OptionsProductComponent,
  DataProductComponent,
  DescripcionProductComponent,
  ProductListComponent,
  BuscadorAdminComponent,
  ContactComponent,
  PaymentListComponent,
  DetailPaymentComponent,
  CardTotalComponent,
  MetricsComponent,
  MetricProductsComponent,
  ProductMetricCardComponent,
  MetricsBarComponent,
  AdminDashboardComponent,
  TransactionComponent,
  UserActionsComponent,
  SegmentComponent,
  SelectionGiftCardComponent,
  SubscriptionUserComponent,
  LinkImageComponent,
  DetailOrdenDirective,
  AttentionComponent,
  ScheduleDispatchComponent,
  RequestGroupComponent,
  UserProofComponent,
  BannerSlidesProductsComponent,
  SlidersOfHomeSectionComponent,
  PasarelaPagoComponent,
  MethodComponent,
  DispatchComponent,
  DecoratedTextComponent,
  DeclineReasonComponent,
  PrintDispatchComponent,
  WithDrawDetailsComponent,
  GroupOptionsComponent,
  QrProfileComponent,
];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    PipeModule,
    ComponentsModuleModule,
    CKEditorModule,
    TranslateModule,
    NgxDatatableModule,
    GeneralesComponentsModule,
    DirectivesModule,
    PipesCompraModule,
    ComponentsCompraModule,

    OwlDateTimeModule,
    OwlNativeDateTimeModule,
  ],
  exports: components,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ComponentsAdminModule {}
